var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#DB4439"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.55 18.9V21.5H19.85C19.7 22.6 18.55 24.75 15.55 24.75C13 24.75 10.85 22.6 10.85 20C10.85 17.35 12.95 15.25 15.55 15.25C17 15.25 18 15.85 18.55 16.4L20.6 14.45C19.3 13.2 17.6 12.5 15.55 12.5C11.4 12.5 8 15.85 8 20.05C8 24.2 11.35 27.6 15.55 27.6C19.9 27.6 22.8 24.55 22.8 20.25C22.8 19.75 22.75 19.4 22.7 19H15.55V18.9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7 18.9H29.55V16.75H27.4V18.9H25.25V21.05H27.4V23.2H29.55V21.05H31.7V18.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.9330122256298eb225887405a1112f56.svg";
export { ForwardRef as ReactComponent };